import { render, staticRenderFns } from "./TechnicalNotes.vue?vue&type=template&id=3f7927d2&scoped=true"
import script from "./TechnicalNotes.vue?vue&type=script&lang=js"
export * from "./TechnicalNotes.vue?vue&type=script&lang=js"
import style0 from "./TechnicalNotes.vue?vue&type=style&index=0&id=3f7927d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7927d2",
  null
  
)

export default component.exports